import { NgModule } from "@angular/core";

import {
    SpsKeyValueListComponent,
    SpsKeyValueListItemComponent,
} from "../components/index";

@NgModule({
    declarations: [
        SpsKeyValueListComponent,
        SpsKeyValueListItemComponent
    ],
    exports: [
        SpsKeyValueListComponent,
        SpsKeyValueListItemComponent
    ]
})
export class SpsKeyValueListModule {}
